import React from 'react';
import {connect} from "react-redux";
import {
  setAutomationPaginationPage,
  setEventsFilters
} from "../../../actions/actions/currentCampaign";
import _ from "i18n";
import {
  fetchAutomationCampaignConfigs,
} from "../../../actions/thunks/campaign";
import uuid from "uuid";
import TTPPaginator from "../../common/list/TTPPaginator";
import ReactTooltip from "react-tooltip";
import {SVG_EDIT_PENCIL_ICON} from "utils";
import Viewer from "../../common/Viewer";
import {TTP_API_URL} from "../../../config";

@connect((store) => {
  return {
    campaignAutomations: store.currentCampaign.email.campaignAutomations,
    automationPageSize: store.currentCampaign.email.automationPageSize,
    automationPaginationPage: store.currentCampaign.email.automationPaginationPage,
    automationNbResult: store.currentCampaign.email.automationNbResult,
    fetching: store.currentCampaign.email.fetching,
    token: store.auth.token,
  }
}, (dispatch) => {
  return {
    fetchAutomationCampaignConfigs: (pageSize, paginationPage) => dispatch(fetchAutomationCampaignConfigs(pageSize, paginationPage)),
    setEventsFilters: (data) => dispatch(setEventsFilters(data)),
    setAutomationPaginationPage : (pageNumber) => dispatch(setAutomationPaginationPage(pageNumber))
  }
})

export default class EmailAutomationOverview extends React.Component {
  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
    this.state = { previewIsOpen: false}
  }

  componentDidMount() {
    if (this.props.render && !this.props.linkAutomationId) {
    this.props.fetchAutomationCampaignConfigs(this.props.automationPageSize, 1);
    }
  }

  handleEdit(automation) {
    const { includedStatus, excludedStatus } = automation;

    const includedFilters = includedStatus ? JSON.parse(includedStatus) : [];
    const excludedFilters = excludedStatus ? JSON.parse(excludedStatus) : [];

    const combinedFilters = [...includedFilters, ...excludedFilters];
    if (combinedFilters.length > 0){
      combinedFilters.map((filter) => {
        this.props.setEventsFilters(filter);
      })
    }

    // Update URL to include automation ID
    const newUrl = `${window.location.pathname}/${automation.id}`;
    window.history.pushState(null, '', newUrl);


    this.props.handleHideCreateAutomation(automation);
  }


  handleAutomationListPageClick(data) {
    let selectedPage = data.selected;
    this.props.setAutomationPaginationPage(selectedPage + 1);
    this.props.fetchAutomationCampaignConfigs(this.props.automationPageSize, selectedPage + 1);
  };

  renderTableBody() {
    const { previewIsOpen } = this.state;
    return (
      <div className="ttp-datatable small-12 columns">
        <div className="row ttp-datatable__header titles-bar" style={{textTransform: 'unset'}}>
          <div className="small-8">{_("automationCampaignName")}</div>
          <div className="small-4">{_("Actions")}</div>
        </div>
        {this.props.campaignAutomations.length === 0 ?
          <div key={uuid()} className="row ttp-datatable__row">
            <div className="small-12" style={{ padding: '1rem', textAlign: 'center', fontSize: '14px', fontWeight: '500'}}>
              {this.props.fetching ? _('Processing') : _('No data found')}
            </div>
          </div>
        : this.props.campaignAutomations.map((automation, index) => {
          return (
            <>
              {previewIsOpen &&
                <Viewer
                  isOpen={previewIsOpen}
                  onClose={() => this.setState({previewIsOpen: false})}
                  url={`${TTP_API_URL}/mailing/web-version?themeId=${automation.theme.id}&textModelId=${automation.textModel?.id}&access_token=${this.props.token}`}
                />
              }
              <div key={uuid()} className="row ttp-datatable__row"
                   style={{ transition: 'background-color 0.2s ease-in-out'}}
                   onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                   onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                <div className="small-8 titles">
                  {automation.name}
                </div>
                <div className="small-4">
                  <div className="list-item__actions">
                    <div
                      data-for={"preview"}
                      data-tip={_("preview")}
                      onClick={() => this.setState({previewIsOpen: true})}
                    >
                      <i className={`icon-left icon-eye`} style={{width: '15px', fontSize: '18px'}}/>
                      <ReactTooltip id={"preview"} type="dark" place="bottom" />
                    </div>
                    <div
                      data-for={"edit"}
                      data-tip={_("edit")}
                      onClick={() => this.handleEdit(automation)}
                    >
                      {SVG_EDIT_PENCIL_ICON}
                      <ReactTooltip id={"edit"} type="dark" place="bottom" />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        })}
        {this.props.automationNbResult > this.props.automationPageSize ?
        <TTPPaginator
          onPageChange={this.handleAutomationListPageClick.bind(this)}
          pageSize={this.props.automationPageSize}
          nbResult={this.props.automationNbResult}
          paginationPage={this.props.automationPaginationPage}
        />
          :
          <></>
        }
      </div>
    );
  }

  render() {
    return (
      <div style={{width: '100%', maxWidth: '64rem', margin: '0 auto'}}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '0.5rem',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          overflow: 'hidden'
        }}>
          <div style={{
            padding: '1.5rem 1.5rem 0',
            backgroundColor: '#f8f9fa',
            border: '1px solid #ddd',
            display: 'flex',
            justifyContent: 'space-between',
          }}>
            <h2 style={{
              fontSize: '1.25rem',
              fontWeight: 500,
              margin: 0,
              color: '#28394C',
            }}>{_('templatesOverview')}
            </h2>
            <div style={{
              backgroundColor: '#f8f9fa',
            }}>
              <button
                className="button primary"
                style={{
                  backgroundColor: '#2196f3',
                  padding: '0.5rem 1rem',
                  border: 'none',
                  borderRadius: '0.25rem',
                  color: 'white',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
                onClick={() => this.props.handleHideCreateAutomation(null)}
              >
                <span style={{fontSize: '16px'}}>{'+ '}</span>{_('createNewTemplate')}
              </button>
            </div>
          </div>
          <div style={{padding: '1.5rem'}}>
              {this.renderTableBody()}
          </div>
        </div>
      </div>
    );
  }
}
